import React, { useEffect, useState } from 'react';


// Appt Components
import Box from '../../components/simple/box/Box.js';
import FormField from '../../components/simple/formField/FormField.js';
import Divider from '../../components/simple/divider/Divider.js';
import TextArea from '../../components/simple/input/TextArea.js';
import Text from '../../components/simple/text/Text.js';




import moment from 'moment';

import FormService from '../../services/FormService.js';
import LocalStorageService from '../../services/LocalStorageService.js';
import FontAwesome from '../../components/compound/fontAwesome/FontAwesome.js';
import ActionButton from '../../components/compound/actionButton/ActionButton.js';


const CommentsForm = (props) => {
    const [formId, setFormId] = useState(props?.formId);
    useEffect(() => { setFormId(props?.formId); }, [props?.formId]);

    const [section, setSection] = useState('General');
    useEffect(() => { 
        if (props?.section) { setSection(props?.section);
    }}, [props?.section]);

    const [comments, setComments] = useState([]);
    useEffect(() => { getComments() }, [formId]);

    const [newComment, setNewComment] = useState('');

    const apiToken = LocalStorageService.get('apiToken');
    const activeOrg = LocalStorageService.get('activeOrg');
    const activeUser = LocalStorageService.get('userDetails');



    const getComments = async () => {
        if (formId) {
            const response = await FormService.getComments(apiToken, formId);
            if (response?.data?.comments) {

                // filter by section
                const filteredComments = response.data.comments.filter(comment => comment.section === props?.section);
                setComments(filteredComments);
            }
        }
    }

    const deleteComment = async (commentId) => {

        // confirm delete
        if (!window.confirm('Are you sure you want to delete this comment?')) {
            return;
        }
        if (formId) {
            const response = await FormService.deleteComment(apiToken, formId, commentId);
            getComments();
        }
    }

    const addComment = async (comment, section = 'general') => {
        if (formId) {
            const response = await FormService.addComment(apiToken, formId, comment, section);
            if (response?.data?.comment?.id) {
                setNewComment('');
                getComments()
            }
        }
    }
  
    return ((comments?.length > 0 || props.isCollaborator) ? <>
        <Divider color="primary" margin={{ top: 'medium', bottom: 'small' }} />
        <Box gap="small" pad="none" margin={{ top: 'none' }} round="xsmall">

            <Text>Collaborator's Comments</Text>
        
            {/* {props?.comments?.length === 0 ? <Text size="small" color="dark-4">No comments have been added yet.</Text> : null}  */}

            <Box gap='xsmall'>
            
                {comments?.map((comment, index) => {
                    return (
                        <Box key={index} gap="xxsmall" pad="small" margin={{ top: 'xsmall' }} border={{ color: 'secondary', size: 'small' }} round="xsmall" style={{ position: 'relative' }}>
                            <Text>
                                <Text size="small" weight="bold" margin={{ right: 'small' }}>{comment?.author?.firstName} {comment?.author?.lastName}</Text>
                                <Text size="xsmall" color="secondary">{moment(comment?.createdAt).format('YYYY-MM-DD HH:mm')}</Text>
                            </Text>
                            <Text>{comment?.content}</Text>
                            
                            {/* Delete icon  - position top right small square icon */}
                            {props.isCollaborator && <Box style={{ position: 'absolute', top: '5px', right: '5px' }} background="primary" round="xsmall" pad="xsmall">
                                <FontAwesome icon={['fal', 'trash']} size="md" color="secondary" onClick={() => { deleteComment(comment?.id) }} /> 
                            </Box>}

                                


                        </Box>
                    )
                })}

            </Box>
            
            {props.isCollaborator && <Box gap="small" pad="small" margin={{ top: 'xsmall' }} border={{ color: 'primary', size: 'small' }} round="xsmall">

                <FormField
                    label={'Your Comment'}
                >
                    <TextArea onChange={(event)=>{ setNewComment(event.target.value) }} />
                </FormField>
                <ActionButton label="Add Comment" primary onClick={() => {
                    if (newComment) {
                        addComment(newComment, section);
                    }
                }
                } />
                <Text size="small">You can add comments to this report. These comments will be visible to all staff members who have access to this report.</Text>
            </Box>}

        </Box>
    </> : null);

}

export default CommentsForm;